import script from "./BaseRangeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRangeInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseRangeInput.vue?vue&type=style&index=0&id=235c4a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235c4a3e"]])

export default __exports__